import { Injectable } from '@angular/core';
import { AuthService } from '../../../../core';

/** Service que valida os acessos e execuções de funcionalidades dos leads */
@Injectable({
    providedIn: 'root'
})
export class LeadAuthGuardService {

    constructor(private authService: AuthService) { }

    /** Verifica se pode editar um lead */
    canEdit(entity: {idUsuarioCreated: number, idUsuarioResponsavel: number}): boolean {
        if (!entity) {
            return false;
        }
        const idUsuarioLogado = this.authService.getIdUsuario();

        // Se for um adminitrador então pode editar
        if (this.authService.isAdministrador()) {
            return true;
        }
        // Se for um representante somente se ele criou o lead ou se é o responsável atual
        if (this.authService.isRepresentante()) {
            // Se não somente o usuário que criou o lead ou responsável atual pelo lead
            return idUsuarioLogado == entity.idUsuarioCreated || idUsuarioLogado == entity.idUsuarioResponsavel;
        }

        return true;
    }

    /** Verifica se pode editar os dados de origem do cliente */
    canEditOrigem(entity: {idUsuarioCreated: number, idUsuarioResponsavel: number, origem: number}, editMode: boolean): boolean {
        if (!this.canEdit(entity)) {
            return false;
        }
        // Somente quando for um novo cliente ou ainda não possuir a origem definida
        return !editMode || !entity.origem
    }

    /** Verifica se pode excluir um lead */
    canDelete(): boolean {
        return true;
    }
}
